const SHOPIFY_DOMAIN = 'marsha-fitness-2.myshopify.com';
const STOREFRONT_TOKEN = 'bd4eeb521c4277cc8133d7f0f507b62d';

export async function shopifyFetch(query, variables = {}) {
    const res = await fetch(`https://${SHOPIFY_DOMAIN}/api/2024-01/graphql.json`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN,
        },
        body: JSON.stringify({ query, variables }),
    });
    return res.json();
}
